const envURL = process.env.REACT_APP_ENV_URL;
const envLabel = process.env.REACT_APP_ENV_LABEL;
const registerBaseUrl = process.env.REACT_APP_REGISTER_BASE_URL;
const aceApiBaseUrl = process.env.REACT_APP_ACE_API_BASE_URL;
const boxBaseUrl = process.env.REACT_APP_BOX_BASE_URL;
const userBaseUrl = process.env.REACT_APP_USER_BASE_URL;
const pactSafeBaseUrl = process.env.REACT_APP_PACTSAFE_BASE_URL;
const pactSafeAccessId = process.env.REACT_APP_PACTSAFE_ACCESS_ID;
const pactSafeSMSGroupKey = process.env.REACT_APP_PACTSAFE_SMS_GROUP_KEY;
const pactSafeSMSGroupId = process.env.REACT_APP_PACTSAFE_SMS_GROUP_ID;
const pactSafeIntroProductGroupKey = process.env.REACT_APP_PACTSAFE_INTRO_PRODUCT_GROUP_KEY;
const pactSafeIntroProductGroupId = process.env.REACT_APP_PACTSAFE_INTRO_PRODUCT_GROUP_ID;
const pactSafeSocialEcommGroupKey = process.env.REACT_APP_PACTSAFE_SOCIAL_ECOMM_SIGN_UP_GROUP_KEY;
const pactSafeSocialEcommGroupId = process.env.REACT_APP_PACTSAFE_SOCIAL_ECOMM_SIGN_UP_GROUP_ID;
const growthBaseUrl = process.env.REACT_APP_GROWTH_BASE_URL;
const maillistBaseUrl = process.env.REACT_APP_MAILLIST_BASE_URL;
const smsListId = process.env.REACT_APP_SMS_LIST_ID;
const smsProspectListId = process.env.REACT_APP_SMS_PROSPECT_LIST_ID;
const gtmContainerId = process.env.REACT_APP_GTM_CONTAINER_ID;
const newMemberApiUrl = process.env.REACT_APP_NEW_MEMBER_API_BASE;
const ldId = process.env.REACT_APP_LD_ID ? process.env.REACT_APP_LD_ID : '';
const originUrl = process.env.REACT_APP_ORIGIN_URL ? process.env.REACT_APP_ORIGIN_URL : '/';
const loginUrl = process.env.REACT_APP_LOGIN_URL;
const localizationUrl = process.env.REACT_APP_LOCALIZATION_URL;
const invitationUrl = process.env.REACT_APP_INVITATION_URL;
const hermesUrl = process.env.REACT_APP_HERMES_URL;
const customizeUrl = process.env.REACT_APP_CUSTOMIZE_API;
const optimizelyId = process.env.REACT_APP_OPTIMIZELY_ID;
const talkBaseUrl = process.env.REACT_APP_TALK_BASE_URL;
const recurlyPublicKey = process.env.REACT_APP_RECURLY_PUBLIC_KEY;
const brainTreePublicKey = process.env.REACT_APP_BRAINTREE_PUBLIC_KEY;
const taxBaseUrl = process.env.REACT_APP_GATSBY_TAX_BASE_URL;
const hCaptchaSiteKey = process.env.REACT_APP_HCAPTCHA_SITEKEY;
const hCaptchaSiteKeyForceChallenge = process.env.REACT_APP_HCAPTCHA_SITEKEY_FORCE_CHALLENGE;
const dataDogId = process.env.REACT_APP_DATADOG_LOGS
  ? process.env.REACT_APP_DATADOG_LOGS
  : 'pubb768a4c83b0ccbb6d2f8f3885ebb365b';
const dataDogRumClientToken = process.env.REACT_APP_DATADOG_RUM_CLIENT_TOKEN;
const dataDogRumAppId = process.env.REACT_APP_DATADOG_RUM_APP_ID;

const env = {
  envURL,
  envLabel,
  registerBaseUrl,
  aceApiBaseUrl,
  boxBaseUrl,
  userBaseUrl,
  pactSafeBaseUrl,
  pactSafeAccessId,
  pactSafeSMSGroupKey,
  pactSafeSMSGroupId,
  pactSafeIntroProductGroupKey,
  pactSafeIntroProductGroupId,
  pactSafeSocialEcommGroupKey,
  pactSafeSocialEcommGroupId,
  growthBaseUrl,
  maillistBaseUrl,
  smsListId,
  smsProspectListId,
  gtmContainerId,
  newMemberApiUrl,
  ldId,
  originUrl,
  loginUrl,
  localizationUrl,
  invitationUrl,
  hermesUrl,
  customizeUrl,
  optimizelyId,
  talkBaseUrl,
  recurlyPublicKey,
  brainTreePublicKey: brainTreePublicKey || 'sandbox_ndz7j27w_6kjmvscwhbbrw5mm',
  hCaptchaSiteKey,
  hCaptchaSiteKeyForceChallenge,
  taxBaseUrl,
  dataDogId,
  dataDogRumClientToken,
  dataDogRumAppId,
};

export default env;
